"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./aggregation"), exports);
tslib_1.__exportStar(require("./param-stream"), exports);
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const noop_1 = tslib_1.__importDefault(require("lodash/noop"));
// Unfortunately, this is legacy support for apps using angularJs.
// This is a slightly modified function we depend on from rx-angular.
// Their implementation breaks once the given `$scope` is destroyed.
rxjs_1.Observable.prototype.safeApply = function ($scope, next = noop_1.default, error = noop_1.default, complete = noop_1.default) {
    return this
        .pipe((0, operators_1.takeWhile)(() => !$scope.$$destroyed), (0, operators_1.tap)((data) => ($scope.$$phase || ((0, get_1.default)($scope.$root, '$$phase'))
        ? next(data)
        : $scope.$apply(() => next(data))), (err) => ($scope.$$phase || ((0, get_1.default)($scope.$root, '$$phase'))
        ? error(err)
        : $scope.$apply(() => error(err))), () => {
        return $scope.$$phase || ((0, get_1.default)($scope.$root, '$$phase'))
            ? complete()
            : $scope.$apply(() => complete());
    }));
};
